import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=60873752&scoped=true"
import script from "./VendorProfile.vue?vue&type=script&lang=js"
export * from "./VendorProfile.vue?vue&type=script&lang=js"
import style0 from "./VendorProfile.vue?vue&type=style&index=0&id=60873752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60873752",
  null
  
)

export default component.exports